import React, { useContext, useState, useEffect } from "react";
import { UserStateContext } from "../../components/context/user-state-context.js";
import { Icon, PageHeaderMui, Toggle } from "../../components";
import { useNavigate } from "react-router-dom";
import {
  Box,
  Button,
  IconButton,
  Paper,
  Stack,
  TextField,
  Tooltip,
  Typography,
  Divider,
  Skeleton,
  InputAdornment,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  OutlinedInput,
  Chip,
  CircularProgress,
} from "@mui/material";
import { ShieldPersonIcon } from "../../components/mui/icon";

export const DashboardList = () => {
  const navigate = useNavigate();
  const { user, asCompany, hasPermission, enabledIntegrationChange, flags } =
    useContext(UserStateContext);
  const [loading, setLoading] = useState(true);

  useEffect(() => {}, []);

  return (
    <>
      <div
        className="wrapper"
        style={{ height: !!loading.length ? "100vh" : "auto" }}
      >
        <PageHeaderMui
          type="Employee Portal - Dashboard"
          icon={<ShieldPersonIcon />}
        />
        <Stack spacing={2}>
          <Box sx={{ px: "20px", pt: "20px", width: "fit-content" }}></Box>
          <Paper sx={{}}>
            <Stack sx={{ p: "20px" }}>
              <Box sx={{ py: "30px" }}> Cinch Operations</Box>
            </Stack>
          </Paper>
        </Stack>
      </div>
    </>
  );
};
